import * as React from 'react';

// Assets
import '../Assets/CoursesListStudent.sass';

// Components
import Navbar from 'Screens/Layout/Common/Components/Navbar';

interface IProps {
    courses: any;
};

const CoursesListStudent = (props: IProps) => (
    <React.Fragment>
        <Navbar navbarClass='navbar-light' />
        <div className='container'>
            <div className='row'>
                <div className='col-md-8 mycourseTitle'>MY COURSES</div>
                <div className='col-md-8'>Click on 'Explore' option to register in courses.</div>
            </div>
            <div className='row courseContainer'>{props.courses}</div>
        </div>
    </React.Fragment>
);

export default CoursesListStudent;
